import { render, staticRenderFns } from "./PageContentCreate.vue?vue&type=template&id=3a8045c1"
import script from "./PageContentCreate.vue?vue&type=script&lang=ts"
export * from "./PageContentCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports